import dayjs from "dayjs";
import { VueCookieNext } from "vue-cookie-next";

const suffixes = {
  genitive: {
    1: "дың",
    2: "ның",
    3: "дың",
    4: "дің",
    5: "дың",
    6: "ның",
    7: "нің",
    8: "дың",
    9: "тің",
    10: "ның",
    11: "ның",
    12: "ның",
  },
  dative: {
    1: "ға",
    2: "ға",
    3: "ға",
    4: "ге",
    5: "ға",
    6: "ға",
    7: "ге",
    8: "ға",
    9: "ке",
    10: "ға",
    11: "ға",
    12: "ға",
  },
  accusative: {
    1: "да",
    2: "да",
    3: "да",
    4: "де",
    5: "да",
    6: "да",
    7: "де",
    8: "да",
    9: "те",
    10: "да",
    11: "да",
    12: "да",
  },
};

/**
 * @typedef {dayjs.Dayjs} DayJS
 */

/**
 * Transforms one date format to another
 *
 * @param {string} date Input date
 * @param {string} format Output format
 * @param {string} parseFormat Input format. Default: YYYY-MM-DD
 * @returns {string}
 */
export const getFormattedDate = (date, format, parseFormat = "YYYY-MM-DD") => {
  return dayjs(date, parseFormat).format(format);
};

/**
 * Returns date text with proper month suffixes
 *
 * @param {string} date Input date | parse format: YYYY-MM-DD(?T...)
 * @param {"accusative"|"dative"|"genitive"} type Month suffix type
 * @param {string} format Date print format
 * @returns {string}
 */
export const getDateText = (date, type, format = "D MMMM") => {
  const monthSuffix =
    suffixes[type][dayjs(date, "YYYY-MM-DD").get("month") + 1];
  return `${getFormattedDate(date, format)}${
    VueCookieNext.getCookie("locale") === "kk-KZ" ? monthSuffix : ""
  }`;
};

/**
 * @param {DayJS|string} date dayjs object
 * @returns {string}
 */
export const getStatementDateFormat = (date) => {
  if (typeof date === "string") {
    date = dayjs(date, "YYYY-MM-DD");
  }
  let dateFormat = "DD MMMM";
  if (date.year() !== dayjs().year()) {
    dateFormat += " `YY";
  }
  return dateFormat;
};
